﻿import common = require("../../../common");
import Vue from 'vue';
import Component from 'vue-class-component';
import core = require("../../../core");
import HotEditableFormManager = require("./HotEditableFormManager");
import HotEditableTextboxComponent = require("./HotEditableTextboxComponent");
import HotEditableSelectComponent = require("./HotEditableSelectComponent");
import SharedHotEditableParentForm = require("./SharedHotEditableParentForm");
import HotEditableMessageComponent = require("./HotEditableMessageComponent");
import AjaxService = require('../../../services/AjaxService');
import context = require("../../context");
import HotEditableFormAction = require("./HotEditableFormAction");
import utilities = require("../../utilities");
import config = require("../../config");
import HotEditableHelpers = require("./HotEditableHelpers");

// Fonction exécutée pour obtenir le template du contrôle (définie dans _HotEditableAddressVueComponent.cshtml)
declare function __getHotEditableAddressComponentTemplate(): string;

interface IHotEditableAddressApiArguments {
    adresse1?: string;
    adresse2?: string;
    idMunicipalite?: string;
    nomSpecifiqueMunicipalite?: string;
    idProvince?: string;
    nomSpecifiqueProvince?: string;
    idPays?: string;
    codePostal?: string;
    idEntity?: string;
    changedFieldName?: string;
}

interface IHotEditableAddressApiResponseData {
    useNomSpecifiqueMunicipaliteTextField: boolean;
    useNomSpecifiqueProvinceTextField: boolean;
    municipalitesEtArrondissementsOptions: common.ISelectOption[];
    provincesOptions: common.ISelectOption[];
    paysOptions: common.ISelectOption[];
    adresse1: string;
    adresse2: string;
    nomSpecifiqueMunicipalite: string;
    nomSpecifiqueProvince: string;
    codePostal: string;
}
enum HeaderLabelStyles {
    unknown = "Unknown",
    default = "Default",
    formHeaderTitleShortSmall = "FormHeaderTitleShortSmall",
    formHeaderTitleShortSmallNoMargin = "FormHeaderTitleShortSmallNoMargin"
}
@Component({
    // Props (attributs sur le tag HTML initial) (les props sont préfixées par 'init' dans prepareMarkup())
    props:
    {
        initId: String,
        initName: String,
        initTabIndex: Number,

        initValueAdresse1: String,
        initValueAdresse2: String,
        initValueMunicipalite: String,
        initValueNomSpecifiqueMunicipalite: String,
        initValueProvince: String,
        initValueNomSpecifiqueProvince: String,
        initValuePays: String,
        initValueCodePostal: String,

        initValueDefaultAdresse1: String,
        initValueDefaultAdresse2: String,
        initValueDefaultMunicipalite: String,
        initValueDefaultNomSpecifiqueMunicipalite: String,
        initValueDefaultProvince: String,
        initValueDefaultNomSpecifiqueProvince: String,
        initValueDefaultPays: String,
        initValueDefaultCodePostal: String,

        initCssClassAdresse1: String,
        initCssClassAdresse2: String,
        initCssClassMunicipalite: String,
        initCssClassNomSpecifiqueMunicipalite: String,
        initCssClassProvince: String,
        initCssClassNomSpecifiqueProvince: String,
        initCssClassPays: String,
        initCssClassCodePostal: String,

        initDisplayNameAdresse1: String,
        initDisplayNameAdresse2: String,
        initDisplayNameMunicipalite: String,
        initDisplayNameNomSpecifiqueMunicipalite: String,
        initDisplayNameProvince: String,
        initDisplayNameNomSpecifiqueProvince: String,
        initDisplayNamePays: String,
        initDisplayNameCodePostal: String,

        initPlaceholderAdresse1: String,
        initPlaceholderAdresse2: String,
        initPlaceholderMunicipalite: String,
        initPlaceholderNomSpecifiqueMunicipalite: String,
        initPlaceholderProvince: String,
        initPlaceholderNomSpecifiqueProvince: String,
        initPlaceholderPays: String,
        initPlaceholderCodePostal: String,

        initRequiredAdresse1: String,
        initRequiredAdresse2: String,
        initRequiredMunicipalite: String,
        initRequiredNomSpecifiqueMunicipalite: String,
        initRequiredProvince: String,
        initRequiredNomSpecifiqueProvince: String,
        initRequiredPays: String,
        initRequiredCodePostal: String,

        initDisabledAdresse1: String,
        initDisabledAdresse2: String,
        initDisabledMunicipalite: String,
        initDisabledNomSpecifiqueMunicipalite: String,
        initDisabledProvince: String,
        initDisabledNomSpecifiqueProvince: String,
        initDisabledPays: String,
        initDisabledCodePostal: String,

        initClearable: Boolean,
        initApiUrl: String,
        initEditModeOn: Boolean,
        initCanChangeEditMode: Boolean,
        initIdEntity: String,
        initLabel: String,
        initHeaderLabelStyle: HeaderLabelStyles,
        initShowLabelOnEdition: Boolean,
        initHideAdresse2Field: Boolean,
        initSummaryInlineMode: Boolean,

        initLabelsSize: String,
        initSummarySize: String,
        initAdresse1Size: String,
        initAdresse2Size: String,
        initMunicipaliteSize: String,
        initNomMunicipaliteSpecSize: String,
        initProvinceSize: String,
        initNomProvinceSpecSize: String,
        initPaysSize: String,
        initCodePostalSize: String
    }
})
class HotEditableAddressComponent extends Vue implements common.IHotEditableFieldComponent, common.IHotEditableFormParentVue {
    shared: SharedHotEditableParentForm;
    formMode: common.HotEditableFormModes;
    formManager: HotEditableFormManager;

    //#region Variables correspondantes aux props
    initId: string;
    initName: string;
    initTabIndex: number;

    initValueAdresse1: string;
    initValueAdresse2: string;
    initValueMunicipalite: string;
    initValueNomSpecifiqueMunicipalite: string;
    initValueProvince: string;
    initValueNomSpecifiqueProvince: string;
    initValuePays: string;
    initValueCodePostal: string;

    initValueDefaultAdresse1: string;
    initValueDefaultAdresse2: string;
    initValueDefaultMunicipalite: string;
    initValueDefaultNomSpecifiqueMunicipalite: string;
    initValueDefaultProvince: string;
    initValueDefaultNomSpecifiqueProvince: string;
    initValueDefaultPays: string;
    initValueDefaultCodePostal: string;

    initCssClassAdresse1: string;
    initCssClassAdresse2: string;
    initCssClassMunicipalite: string;
    initCssClassNomSpecifiqueMunicipalite: string;
    initCssClassProvince: string;
    initCssClassNomSpecifiqueProvince: string;
    initCssClassPays: string;
    initCssClassCodePostal: string;

    initDisplayNameAdresse1: string;
    initDisplayNameAdresse2: string;
    initDisplayNameMunicipalite: string;
    initDisplayNameNomSpecifiqueMunicipalite: string;
    initDisplayNameProvince: string;
    initDisplayNameNomSpecifiqueProvince: string;
    initDisplayNamePays: string;
    initDisplayNameCodePostal: string;

    initPlaceholderAdresse1: string;
    initPlaceholderAdresse2: string;
    initPlaceholderMunicipalite: string;
    initPlaceholderNomSpecifiqueMunicipalite: string;
    initPlaceholderProvince: string;
    initPlaceholderNomSpecifiqueProvince: string;
    initPlaceholderPays: string;
    initPlaceholderCodePostal: string;

    initRequiredAdresse1: string;
    initRequiredAdresse2: string;
    initRequiredMunicipalite: string;
    initRequiredNomSpecifiqueMunicipalite: string;
    initRequiredProvince: string;
    initRequiredNomSpecifiqueProvince: string;
    initRequiredPays: string;
    initRequiredCodePostal: string;

    initDisabledAdresse1: string;
    initDisabledAdresse2: string;
    initDisabledMunicipalite: string;
    initDisabledNomSpecifiqueMunicipalite: string;
    initDisabledProvince: string;
    initDisabledNomSpecifiqueProvince: string;
    initDisabledPays: string;
    initDisabledCodePostal: string;

    initLabelsSize: string;
    initSummarySize: string;
    initAdresse1Size: string;
    initAdresse2Size: string;
    initMunicipaliteSize: string;
    initNomMunicipaliteSpecSize: string;
    initProvinceSize: string;
    initNomProvinceSpecSize: string;
    initPaysSize: string;
    initCodePostalSize: string;

    initClearable: boolean;
    initApiUrl: string;
    initEditModeOn: boolean;
    initCanChangeEditMode: boolean;
    initIdEntity: string;
    initLabel: string;
    initHeaderLabelStyle: HeaderLabelStyles;
    initShowLabelOnEdition: boolean;
    initHideAdresse2Field: boolean;
    initSummaryInlineMode: boolean;

    //#endregion Variables correspondantes aux props

    //#region Variables correspondantes à l'objet data

    idElementAdresse1: string;
    idElementAdresse2: string;
    idElementMunicipalite: string;
    idElementNomSpecifiqueMunicipalite: string;
    idElementProvince: string;
    idElementNomSpecifiqueProvince: string;
    idElementPays: string;
    idElementCodePostal: string;

    elementNameAdresse1: string;
    elementNameAdresse2: string;
    elementNameMunicipalite: string;
    elementNameNomSpecifiqueMunicipalite: string;
    elementNameProvince: string;
    elementNameNomSpecifiqueProvince: string;
    elementNamePays: string;
    elementNameCodePostal: string;

    cssClassAdresse1: string;
    cssClassAdresse2: string;
    cssClassMunicipalite: string;
    cssClassNomSpecifiqueMunicipalite: string;
    cssClassProvince: string;
    cssClassNomSpecifiqueProvince: string;
    cssClassPays: string;
    cssClassCodePostal: string;

    tabIndexAdresse1: number;
    tabIndexAdresse2: number;
    tabIndexMunicipalite: number;
    tabIndexNomSpecifiqueMunicipalite: number;
    tabIndexProvince: number;
    tabIndexNomSpecifiqueProvince: number;
    tabIndexPays: number;
    tabIndexCodePostal: number;

    requiredAdresse1: string;
    requiredAdresse2: string;
    requiredMunicipalite: string;
    requiredNomSpecifiqueMunicipalite: string;
    requiredProvince: string;
    requiredNomSpecifiqueProvince: string;
    requiredPays: string;
    requiredCodePostal: string;

    disabledAdresse1: string;
    disabledAdresse2: string;
    disabledMunicipalite: string;
    disabledNomSpecifiqueMunicipalite: string;
    disabledProvince: string;
    disabledNomSpecifiqueProvince: string;
    disabledPays: string;
    disabledCodePostal: string;

    // Valeur affichée en mode lecture (label) quand aucune valeur n'est sélectionnée.
    valueDefaultAdresse1: string;
    valueDefaultAdresse2: string;
    valueDefaultMunicipalite: string;
    valueDefaultNomSpecifiqueMunicipalite: string;
    valueDefaultProvince: string;
    valueDefaultNomSpecifiqueProvince: string;
    valueDefaultPays: string;
    valueDefaultCodePostal: string;

    // Champ utilisé pour identifier le champ lors des messages aux utilisateurs.
    displayNameAdresse1: string;
    displayNameAdresse2: string;
    displayNameMunicipalite: string;
    displayNameNomSpecifiqueMunicipalite: string;
    displayNameProvince: string;
    displayNameNomSpecifiqueProvince: string;
    displayNamePays: string;
    displayNameCodePostal: string;

    // Message affiché quand le champ n'a pas de sélection en mode édition.
    placeholderAdresse1: string;
    placeholderAdresse2: string;
    placeholderMunicipalite: string;
    placeholderNomSpecifiqueMunicipalite: string;
    placeholderProvince: string;
    placeholderNomSpecifiqueProvince: string;
    placeholderPays: string;
    placeholderCodePostal: string;

    rootId: string;
    idEntity: string;
    label: string;
    headerLabelStyle: HeaderLabelStyles;
    showLabelOnEdition: boolean;
    hideAdresse2Field: boolean;
    //isInitialLoading: boolean;
    editModeOn: boolean;
    canChangeEditMode: boolean;
    apiUrl: string;
    clearable: boolean;
    hasError: boolean;
    tabIndex: number;
    elementValue: string;
    useNomSpecifiqueMunicipaliteTextField: boolean;
    useNomSpecifiqueProvinceTextField: boolean;
    summaryInlineMode: boolean;
    isParent = true;

    // Messages
    messageIdAdresse1: string;
    messageIdAdresse2: string;
    messageIdMunicipalite: string;
    messageIdNomSpecifiqueMunicipalite: string;
    messageIdProvince: string;
    messageIdNomSpecifiqueProvince: string;
    messageIdPays: string;
    messageIdCodePostal: string;

    messageCssClassAdresse1: string;
    messageCssClassAdresse2: string;
    messageCssClassMunicipalite: string;
    messageCssClassNomSpecifiqueMunicipalite: string;
    messageCssClassProvince: string;
    messageCssClassNomSpecifiqueProvince: string;
    messageCssClassPays: string;
    messageCssClassCodePostal: string;

    messageFieldNameAdresse1: string;
    messageFieldNameAdresse2: string;
    messageFieldNameMunicipalite: string;
    messageFieldNameNomSpecifiqueMunicipalite: string;
    messageFieldNameProvince: string;
    messageFieldNameNomSpecifiqueProvince: string;
    messageFieldNamePays: string;
    messageFieldNameCodePostal: string;

    // Sizes
    labelsSize: string;
    adresse1Size: string;
    adresse2Size: string;
    municipaliteSize: string;
    nomMunicipaliteSpecSize: string;
    provinceSize: string;
    nomProvinceSpecSize: string;
    paysSize: string;
    codePostalSize: string;

    // Summaries
    adresse1Summary: string;
    adresse2Summary: string;
    municipaliteSummary: string;
    provinceSummary: string;
    paysSummary: string;
    codePostalSummary: string;

    //#endregion Variables correspondantes à l'objet data

    // Autres variables
    idElement: string; // Obligatoire dans l'interface
    elementName: string; // Obligatoire dans l'interface
    fieldType = common.HotEditableFieldTypes.address;
    isApiRunning = false;
    private afterFetchAction: () => void;

    // Champs HotEditable du formulaire
    fieldAdresse1: HotEditableTextboxComponent;
    fieldAdresse2: HotEditableTextboxComponent;
    fieldMunicipalite: HotEditableSelectComponent;
    fieldNomSpecifiqueMunicipalite: HotEditableTextboxComponent;
    fieldProvince: HotEditableSelectComponent;
    fieldNomSpecifiqueProvince: HotEditableTextboxComponent;
    fieldPays: HotEditableSelectComponent;
    fieldCodePostal: HotEditableTextboxComponent;

    // Max length
    maxLengthAdresse1: number;
    maxLengthAdresse2: number;
    maxLengthNomSpecifiqueMunicipalite: number;
    maxLengthNomSpecifiqueProvince: number;
    maxLengthCodePostal: number;

    // Previous values
    _previousValue: string;
    _previousFieldValueAdresse1: any;
    _previousFieldValueAdresse2: any;
    _previousFieldValueMunicipalite: any;
    _previousFieldValueNomSpecifiqueMunicipalite: any;
    _previousFieldValueProvince: any;
    _previousFieldValueNomSpecifiqueProvince: any;
    _previousFieldValuePays: any;
    _previousFieldValueCodePostal: any;

    _previousUseNomSpecifiqueMunicipaliteTextField: boolean;
    _previousUseNomSpecifiqueProvinceTextField: boolean;

    _previousDisabledValues: {};
    _paysId_canada = null as string;
    _displayFormater_postalCodeCa = null as common.ITextFormater;
    _formManagerParent: HotEditableFormManager;//NOTE: Doit undefined initialement car il est definie dans le "beforeCreate"
    _ajaxService = null as AjaxService;

    static tagName = "hoteditableaddress";

    static defaultValue() {
        return {} as IHotEditableAddressApiArguments;
    }

    data() {
        const guid = utilities.createGuid('N');
        const id = this.initId || "Field_" + guid;
        const name = this.initName || id;
        const tabIndex = this.initTabIndex || -1;
        // inner ids
        const fieldAdresse1Id = id + "_Adresse1";
        const fieldAdresse2Id = id + "_Adresse2";
        const fieldMunicipaliteId = id + "_Municipalite";
        const fieldNomSpecifiqueMunicipaliteId = id + "_NomSpecifiqueMunicipalite";
        const fieldProvinceId = id + "_Province";
        const fieldNomSpecifiqueProvinceId = id + "_NomSpecifiqueProvince";
        const fieldPaysId = id + "_Pays";
        const fieldCodePostalId = id + "_CodePostal";
        // inner names
        const fieldAdresse1Name = name + "_Adresse1";
        const fieldAdresse2Name = name + "_Adresse2";
        const fieldMunicipaliteName = name + "_Municipalite";
        const fieldNomSpecifiqueMunicipaliteName = name + "_NomSpecifiqueMunicipalite";
        const fieldProvinceName = name + "_Province";
        const fieldNomSpecifiqueProvinceName = name + "_NomSpecifiqueProvince";
        const fieldPaysName = name + "_Pays";
        const fieldCodePostalName = name + "_CodePostal";
        // default max length
        const defaultMaxLengthAdresse1 = 250;
        const defaultMaxLengthAdresse2 = 250;
        const defaultMaxLengthNomSpecifiqueMunicipalite = 250;
        const defaultMaxLengthNomSpecifiqueProvince = 250;
        const defaultMaxLengthCodePostal = 10;

        const o = {
            rootId: "HotEditableField_" + guid,
            idElement: id,
            idElementAdresse1: fieldAdresse1Id,
            idElementAdresse2: fieldAdresse2Id,
            idElementMunicipalite: fieldMunicipaliteId,
            idElementNomSpecifiqueMunicipalite: fieldNomSpecifiqueMunicipaliteId,
            idElementProvince: fieldProvinceId,
            idElementNomSpecifiqueProvince: fieldNomSpecifiqueProvinceId,
            idElementPays: fieldPaysId,
            idElementCodePostal: fieldCodePostalId,

            elementName: name,
            elementNameAdresse1: fieldAdresse1Name,
            elementNameAdresse2: fieldAdresse2Name,
            elementNameMunicipalite: fieldMunicipaliteName,
            elementNameNomSpecifiqueMunicipalite: fieldNomSpecifiqueMunicipaliteName,
            elementNameProvince: fieldProvinceName,
            elementNameNomSpecifiqueProvince: fieldNomSpecifiqueProvinceName,
            elementNamePays: fieldPaysName,
            elementNameCodePostal: fieldCodePostalName,

            cssClassAdresse1: this.initCssClassAdresse1 || '',
            cssClassAdresse2: this.initCssClassAdresse2 || '',
            cssClassMunicipalite: this.initCssClassMunicipalite || '',
            cssClassNomSpecifiqueMunicipalite: this.initCssClassNomSpecifiqueMunicipalite || '',
            cssClassProvince: this.initCssClassProvince || '',
            cssClassNomSpecifiqueProvince: this.initCssClassNomSpecifiqueProvince || '',
            cssClassPays: this.initCssClassPays || '',
            cssClassCodePostal: this.initCssClassCodePostal || '',

            tabIndexAdresse1: tabIndex,
            tabIndexAdresse2: tabIndex + 1,
            tabIndexMunicipalite: tabIndex + 2,
            tabIndexNomSpecifiqueMunicipalite: tabIndex + 3,
            tabIndexProvince: tabIndex + 4,
            tabIndexNomSpecifiqueProvince: tabIndex + 5,
            tabIndexPays: tabIndex + 6,
            tabIndexCodePostal: tabIndex + 7,

            requiredAdresse1: this.initRequiredAdresse1,
            requiredAdresse2: this.initRequiredAdresse2,
            requiredMunicipalite: this.initRequiredMunicipalite,
            requiredNomSpecifiqueMunicipalite: this.initRequiredNomSpecifiqueMunicipalite,
            requiredProvince: this.initRequiredProvince,
            requiredNomSpecifiqueProvince: this.initRequiredNomSpecifiqueProvince,
            requiredPays: this.initRequiredPays,
            requiredCodePostal: this.initRequiredCodePostal,

            disabledAdresse1: this.initDisabledAdresse1,
            disabledAdresse2: this.initDisabledAdresse2,
            disabledMunicipalite: this.initDisabledMunicipalite,
            disabledNomSpecifiqueMunicipalite: this.initDisabledNomSpecifiqueMunicipalite,
            disabledProvince: this.initDisabledProvince,
            disabledNomSpecifiqueProvince: this.initDisabledNomSpecifiqueProvince,
            disabledPays: this.initDisabledPays,
            disabledCodePostal: this.initDisabledCodePostal,

            // Valeur affichée en mode lecture (label) quand aucune valeur n'est sélectionnée.
            valueDefaultAdresse1: this.initValueDefaultAdresse1 || '',
            valueDefaultAdresse2: this.initValueDefaultAdresse2 || '',
            valueDefaultMunicipalite: this.initValueDefaultMunicipalite || '',
            valueDefaultNomSpecifiqueMunicipalite: this.initValueDefaultNomSpecifiqueMunicipalite || '',
            valueDefaultProvince: this.initValueDefaultProvince || '',
            valueDefaultNomSpecifiqueProvince: this.initValueDefaultNomSpecifiqueProvince || '',
            valueDefaultPays: this.initValueDefaultPays || '',
            valueDefaultCodePostal: this.initValueDefaultCodePostal || '',

            // Champ utilisé pour identifier le champ lors des messages aux utilisateurs.
            displayNameAdresse1: this.initDisplayNameAdresse1 || null,
            displayNameAdresse2: this.initDisplayNameAdresse2 || null,
            displayNameMunicipalite: this.initDisplayNameMunicipalite || null,
            displayNameNomSpecifiqueMunicipalite: this.initDisplayNameNomSpecifiqueMunicipalite || null,
            displayNameProvince: this.initDisplayNameProvince || null,
            displayNameNomSpecifiqueProvince: this.initDisplayNameNomSpecifiqueProvince || null,
            displayNamePays: this.initDisplayNamePays || null,
            displayNameCodePostal: this.initDisplayNameCodePostal || null,

            // Message affiché quand le champ n'a pas de sélection en mode édition.
            placeholderAdresse1: this.initPlaceholderAdresse1 || '',
            placeholderAdresse2: this.initPlaceholderAdresse2 || '',
            placeholderMunicipalite: this.initPlaceholderMunicipalite || '',
            placeholderNomSpecifiqueMunicipalite: this.initPlaceholderNomSpecifiqueMunicipalite || '',
            placeholderProvince: this.initPlaceholderProvince || '',
            placeholderNomSpecifiqueProvince: this.initPlaceholderNomSpecifiqueProvince || '',
            placeholderPays: this.initPlaceholderPays || '',
            placeholderCodePostal: this.initPlaceholderCodePostal || '',

            // elementValueAdresse1: this.initValueAdresse1 || null,
            // elementValueAdresse2: this.initValueAdresse2 || null,
            // elementValueMunicipalite: this.initValueMunicipalite || null,
            // elementValueNomSpecifiqueMunicipalite: this.initValueNomSpecifiqueMunicipalite || null,
            // elementValueProvince: this.initValueProvince || null,
            // elementValueNomSpecifiqueProvince: this.initValueNomSpecifiqueProvince || null,
            // elementValuePays: this.initValuePays || null,
            // elementValueCodePostal: this.initValueCodePostal || null,

            idEntity: this.initIdEntity || null,
            label: this.initLabel || null,
            headerLabelStyle: this.initHeaderLabelStyle || 'Default',
            showLabelOnEdition: this.initShowLabelOnEdition === true,
            hideAdresse2Field: this.initHideAdresse2Field === true,
            //isInitialLoading: true,
            ignoreInnerAction: true,
            editModeOn: this.initEditModeOn === true,
            canChangeEditMode: this.initCanChangeEditMode === true,
            apiUrl: this.initApiUrl || (() => { throw "L'URL de l'API est requis (attribut 'init-api-url')"; })(),
            clearable: this.initClearable === true,
            hasError: false,
            tabIndex: tabIndex,
            elementValue: '',
            useNomSpecifiqueMunicipaliteTextField: false,
            useNomSpecifiqueProvinceTextField: false,
            summaryInlineMode: this.initSummaryInlineMode,

            // Messages
            messageIdAdresse1: fieldAdresse1Id + "Message",
            messageIdAdresse2: fieldAdresse2Id + "Message",
            messageIdMunicipalite: fieldMunicipaliteId + "Message",
            messageIdNomSpecifiqueMunicipalite: fieldNomSpecifiqueMunicipaliteId + "Message",
            messageIdProvince: fieldProvinceId + "Message",
            messageIdNomSpecifiqueProvince: fieldNomSpecifiqueProvinceId + "Message",
            messageIdPays: fieldPaysId + "Message",
            messageIdCodePostal: fieldCodePostalId + "Message",

            messageFieldNameAdresse1: fieldAdresse1Name,
            messageFieldNameAdresse2: fieldAdresse2Name,
            messageFieldNameMunicipalite: fieldMunicipaliteName,
            messageFieldNameNomSpecifiqueMunicipalite: fieldNomSpecifiqueMunicipaliteName,
            messageFieldNameProvince: fieldProvinceName,
            messageFieldNameNomSpecifiqueProvince: fieldNomSpecifiqueProvinceName,
            messageFieldNamePays: fieldPaysName,
            messageFieldNameCodePostal: fieldCodePostalName,

            messageCssClassAdresse1: null,
            messageCssClassAdresse2: null,
            messageCssClassMunicipalite: null,
            messageCssClassNomSpecifiqueMunicipalite: null,
            messageCssClassProvince: null,
            messageCssClassNomSpecifiqueProvince: null,
            messageCssClassPays: null,
            messageCssClassCodePostal: null,

            // Sizes
            labelsSize: this.initLabelsSize || '',
            summarySize: this.initSummarySize || '',
            adresse1Size: this.initAdresse1Size || '',
            adresse2Size: this.initAdresse2Size || '',
            municipaliteSize: this.initMunicipaliteSize || '',
            nomMunicipaliteSpecSize: this.initNomMunicipaliteSpecSize || '',
            provinceSize: this.initProvinceSize || '',
            nomProvinceSpecSize: this.initNomProvinceSpecSize || '',
            paysSize: this.initPaysSize || '',
            codePostalSize: this.initCodePostalSize || '',

            // Summaries
            adresse1Summary: "",
            adresse2Summary: "",
            municipaliteSummary: "",
            provinceSummary: "",
            paysSummary: "",
            codePostalSummary: "",
            showMunicipaliteDetails: false,

            // Max length
            maxLengthAdresse1: defaultMaxLengthAdresse1,
            maxLengthAdresse2: defaultMaxLengthAdresse2,
            maxLengthNomSpecifiqueMunicipalite: defaultMaxLengthNomSpecifiqueMunicipalite,
            maxLengthNomSpecifiqueProvince: defaultMaxLengthNomSpecifiqueProvince,
            maxLengthCodePostal: defaultMaxLengthCodePostal,

            _previousUseNomSpecifiqueMunicipaliteTextField: false,
            _previousUseNomSpecifiqueProvinceTextField: false
        };

        return o;
    }

    /** Fonction système exécutée automatiquement AVANT le constructeur (!!!) */
    beforeCreate() {
        this._formManagerParent = ((this.$parent as any).formManager as HotEditableFormManager).registerField(this);

        const formName = this._formManagerParent.getFormName();
        this.formManager = new HotEditableFormManager(this, formName).setFocusCallbacksFromField(
            () => this._formManagerParent.focusPreviousComponentFromField(this),
            () => this._formManagerParent.focusNextComponentFromField(this));

        this.shared = new SharedHotEditableParentForm(this.formManager).setActionCallback(a => {
            this.onInnerFormChange(a);
        });

        const c = {};
        c[HotEditableTextboxComponent.tagName] = HotEditableTextboxComponent;
        c[HotEditableSelectComponent.tagName] = HotEditableSelectComponent;
        c[HotEditableMessageComponent.tagName] = HotEditableMessageComponent;
        this.$options.components = c;
        this.$options.template = __getHotEditableAddressComponentTemplate();
    }

    created() {
        const contextCanadaId = ((context as any).countryIds || {})['canada'] as string;
        if (!contextCanadaId)
            throw "Le ID du pays 'Canada' n'existe pas dans le JsContext.";
        this._paysId_canada = contextCanadaId.trim().toLowerCase();

        this._displayFormater_postalCodeCa = config.textFormaters['postal-code--ca'];
    }

    mounted() {
        HotEditableHelpers.validateFieldSettings(this);

        (this.$el as Element).removeAttribute("hot-editable-cloak");

        this._ajaxService = new AjaxService();

        this._previousDisabledValues = {};
        this.fieldAdresse1 = this.formManager.getFieldByName(this.elementNameAdresse1) as HotEditableTextboxComponent;
        this.fieldAdresse2 = this.formManager.getFieldByName(this.elementNameAdresse2) as HotEditableTextboxComponent;
        this.fieldMunicipalite = this.formManager.getFieldByName(this.elementNameMunicipalite) as HotEditableSelectComponent;
        this.fieldNomSpecifiqueMunicipalite = this.formManager.getFieldByName(this.elementNameNomSpecifiqueMunicipalite) as HotEditableTextboxComponent;
        this.fieldProvince = this.formManager.getFieldByName(this.elementNameProvince) as HotEditableSelectComponent;
        this.fieldNomSpecifiqueProvince = this.formManager.getFieldByName(this.elementNameNomSpecifiqueProvince) as HotEditableTextboxComponent;
        this.fieldPays = this.formManager.getFieldByName(this.elementNamePays) as HotEditableSelectComponent;
        this.fieldCodePostal = this.formManager.getFieldByName(this.elementNameCodePostal) as HotEditableTextboxComponent;

        this.fetchWithValues(
            false,
            this.initValueAdresse1,
            this.initValueAdresse2,
            this.initValueMunicipalite,
            this.initValueNomSpecifiqueMunicipalite,
            this.initValueProvince,
            this.initValueNomSpecifiqueProvince,
            this.initValuePays,
            this.initValueCodePostal,
            true);

        // permet de faire fonctionner les esc/tab/enter
        document.addEventListener("keydown", e => {
            if (!this.canChangeEditMode || !this.editModeOn)
                return;

            const isEnter = utilities.isEnterKeyCode(e);
            const isEscape = !isEnter && utilities.isEscapeKeyCode(e);
            const isTab = !isEnter && !isEscape && utilities.isTabKeyCode(e);

            if (isEnter || isEscape || isTab) {
                //this.preventDefault(e);
                //e.stopImmediatePropagation();// IMPORTANT: Necessite de stopper tout les events (et pas que ceux du/des parent(s)) en raison du $nextTick dans le Changed.

                const isShifted = e.shiftKey;
                if (isShifted) {
                    if (isTab) {
                        // check if is first focus
                        if (document.activeElement && (document.activeElement as any).name === this.fieldAdresse1.elementName)
                            setTimeout(() => {
                                this.onShiftTabClick(e);
                            }, 1);
                    }
                } else {
                    if (isEscape) {
                        this.onEscapeClick(e);
                    } else if (isTab) {
                        // check if is last focus
                        if (document.activeElement && (document.activeElement as any).name === this.fieldCodePostal.elementName)
                            setTimeout(() => {
                                this.onTabClick(e);
                            }, 1);
                    }
                    else if (isEnter) {
                        this.onEnterClick(e);
                    }
                }
            }
        });

        // permet de faire fonctionner le blur
        document.addEventListener("mousedown", e => {
            if (!this.canChangeEditMode || !this.editModeOn)
                return;
            const root = this.$refs["root"] as Element;

            if (!this.hasEmbeddedFieldError() && utilities.isOutside(e.target as Element, root))
                this.onBlur(e);
        });
    }

    hasEmbeddedFieldError() {
        return this.fieldAdresse1.hasError ||
            this.fieldAdresse2.hasError ||
            this.fieldCodePostal.hasError ||
            this.fieldMunicipalite.hasError ||
            this.fieldProvince.hasError ||
            this.fieldPays.hasError ||
            this.fieldNomSpecifiqueMunicipalite.hasError ||
            this.fieldNomSpecifiqueProvince.hasError;
    }

    //getElementValueAdresse1OrInitialValue() { return this.fieldAdresse1 ? this.fieldAdresse1.elementValue : this.initValueAdresse1; }
    //getElementValueAdresse2OrInitialValue() { return this.fieldAdresse2 ? this.fieldAdresse2.elementValue : this.initValueAdresse2; }
    //getElementValueMunicipaliteOrInitialValue() { return this.fieldMunicipalite ? this.fieldMunicipalite.elementValue : this.initValueMunicipalite; }
    //getElementValueNomSpecifiqueMunicipaliteOrInitialValue() { return this.fieldNomSpecifiqueMunicipalite ? this.fieldNomSpecifiqueMunicipalite.elementValue : this.initValueNomSpecifiqueMunicipalite; }
    //getElementValueProvinceOrInitialValue() { return this.fieldProvince ? this.fieldProvince.elementValue : this.initValueProvince; }
    //getElementValueNomSpecifiqueProvinceOrInitialValue() { return this.fieldNomSpecifiqueProvince ? this.fieldNomSpecifiqueProvince.elementValue : this.initValueNomSpecifiqueProvince; }
    getElementValuePaysOrInitialValue() { return this.fieldPays ? this.fieldPays.elementValue : this.initValuePays; }
    getElementValueCodePostalOrInitialValue() { return this.fieldCodePostal ? this.fieldCodePostal.elementValue : this.initValueCodePostal; }

    changeMode(canChangeEditMode: boolean, editModeOn: boolean) {
        this.canChangeEditMode = canChangeEditMode;
        this.editModeOn = editModeOn;

        return this;
    }

    setFromTextualValue(textualValue?: string) {
        if (!textualValue)
            return;

        const args = JSON.parse(textualValue) as IHotEditableAddressApiArguments;

        this.innerFetch(args, false);

        return this;
    }

    isRequired() {
        return this.requiredAdresse1 &&
            this.requiredAdresse2 &&
            this.requiredMunicipalite &&
            this.requiredNomSpecifiqueMunicipalite &&
            this.requiredProvince &&
            this.requiredNomSpecifiqueProvince &&
            this.requiredPays &&
            this.requiredCodePostal
    }

    /** Formater le code postal canadien (XXX XXX) */
    getFormatedDisplay_codePostal(elementValueCodePostal: string, elementValuePays: string | common.IHotEditableSelectOption) {

        if (!elementValuePays)
            return (elementValueCodePostal || '').trim().toUpperCase();

        const currentPaysId = elementValuePays
            ? ((elementValuePays as common.IHotEditableSelectOption).code ?? (elementValuePays as string)).trim().toLowerCase()
            : '';

        if (currentPaysId !== this._paysId_canada)
            return (elementValueCodePostal || '').trim().toUpperCase();

        return this._displayFormater_postalCodeCa.format(elementValueCodePostal);
    }

    getTextualValue() {
        const json = this.getHotEditableAddressApiArgumentsAsJson();
        return json;
    }

    onChanged(event: Event) {
        this.preventDefault(event);
        this.changed();
    }

    onCancel(event: Event) {
        this.preventDefault(event);
        this.cancel();
    }

    onClear(event: Event) {
        this.preventDefault(event);
        this.clear();
    }
    private preventDefault(e?: Event, bypassStopPropagation?: boolean) {
        if (!e)
            return;

        e.preventDefault();

        if (bypassStopPropagation !== true)
            e.stopPropagation();
    }
    clear() {
        if (!this.fieldAdresse1.disabled)
            this.fieldAdresse1.clear();

        if (!this.fieldAdresse2.disabled)
            this.fieldAdresse2.clear();

        if (!this.fieldMunicipalite.disabled)
            this.fieldMunicipalite.clear();

        if (!this.fieldNomSpecifiqueMunicipalite.disabled)
            this.fieldNomSpecifiqueMunicipalite.clear();

        if (!this.fieldProvince.disabled)
            this.fieldProvince.clear();

        if (!this.fieldNomSpecifiqueProvince.disabled)
            this.fieldNomSpecifiqueProvince.clear();

        //NOTE: PAS CLEARABLE POUR L'INSTANT (NE PAS SUPPRIMER)
        //if (!this.fieldPays.disabled)
        //    this.fieldPays.clear();

        if (!this.fieldCodePostal.disabled)
            this.fieldCodePostal.clear();
    }

    /** Fonction éxécutée lorsque l'utilisateur clique sur le bouton d'annulation de l'édition */
    cancel() {
        if (!this.canChangeEditMode)
            return;

        //@@fetetrault: en test...        
        this.restorePreviousInnerFieldValues();
        this.innerChanged(false, false);
        // this.elementValue = this._previousValue;

        //@@fetetrault: en test...
        // this.fieldAdresse1.cancel();
        // this.fieldAdresse2.cancel();
        // this.fieldMunicipalite.cancel();
        // this.fieldNomSpecifiqueMunicipalite.cancel();
        // this.fieldProvince.cancel();
        // this.fieldNomSpecifiqueProvince.cancel();
        // this.fieldPays.cancel();
        // this.fieldCodePostal.cancel();

        this.formManager.autoCloseMessages();

        this.updateSummariesFromFields();

        this.editModeOn = false;
    }

    /** Fonction éxécutée lorsque l'utilisateur effectue un choix dans la liste déroulante (from: vue-select) */
    changed() {
        this.innerChanged();
    }
    getMunicipaliteSummaryParts() {
        const r = {
            name: '',
            details: ''
        };
        if (this.municipaliteSummary) {
            const parts = this.municipaliteSummary.split("(");
            r.name = parts[0].trim();
            r.details = parts.length <= 1 ? '' : " (" + parts[1];
        }
        return r;
    }
    updateAllDisabled(value?: boolean) {
        value = value !== false;//default is TRUE
        const fields = this.getAllFields();
        for (let i = 0; i < fields.length; i++) {
            const f = fields[i];
            this._previousDisabledValues[f.elementName] = f.disabled;
            f.disabled = value;
        }
    }
    restoreAllOriginalDisabledValues() {
        const fields = this.getAllFields();
        for (let i = 0; i < fields.length; i++) {
            const f = fields[i];
            if (this._previousDisabledValues[f.elementName] === true || this._previousDisabledValues[f.elementName] === false)
                f.disabled = this._previousDisabledValues[f.elementName];
        }
    }
    private getAllFields() {
        return [
            this.fieldAdresse1,
            this.fieldAdresse2,
            this.fieldCodePostal,
            this.fieldMunicipalite,
            this.fieldNomSpecifiqueMunicipalite,
            this.fieldNomSpecifiqueProvince,
            this.fieldPays,
            this.fieldProvince
        ];
    }
    private updatePreviousValue() {
        this._previousValue = this.elementValue;
    }
    private updatePreviousInnerFieldValues() {
        //NOTE: L'hypothese qui explique que 'elementValue' doit etre utilise plutot que '_previousValue' dans le cas des dropdowns est que le 'vue-select' est traite un ou plusieurs cycle(s) plus tard et, donc, 'elementValue' contient ici encore la valeur precendente (non mise a jour).

        this._previousFieldValueAdresse1 = this.fieldAdresse1._previousValue;
        this._previousFieldValueAdresse2 = this.fieldAdresse2._previousValue;
        this._previousFieldValueMunicipalite = this.fieldMunicipalite._previousValue;
        this._previousFieldValueNomSpecifiqueMunicipalite = this.fieldNomSpecifiqueMunicipalite._previousValue;
        this._previousFieldValueProvince = this.fieldProvince._previousValue;
        this._previousFieldValueNomSpecifiqueProvince = this.fieldNomSpecifiqueProvince._previousValue;
        this._previousFieldValuePays = this.fieldPays._previousValue;
        this._previousFieldValueCodePostal = this.fieldCodePostal._previousValue;

        this._previousUseNomSpecifiqueMunicipaliteTextField = this.useNomSpecifiqueMunicipaliteTextField;
        this._previousUseNomSpecifiqueProvinceTextField = this.useNomSpecifiqueProvinceTextField;
    }
    private restorePreviousInnerFieldValues() {
        this.fieldAdresse1.elementValue = this._previousFieldValueAdresse1;
        this.fieldAdresse2.elementValue = this._previousFieldValueAdresse2;
        this.fieldMunicipalite.elementValue = this._previousFieldValueMunicipalite;
        this.fieldNomSpecifiqueMunicipalite.elementValue = this._previousFieldValueNomSpecifiqueMunicipalite;
        this.fieldProvince.elementValue = this._previousFieldValueProvince;
        this.fieldNomSpecifiqueProvince.elementValue = this._previousFieldValueNomSpecifiqueProvince;
        this.fieldPays.elementValue = this._previousFieldValuePays;
        this.fieldCodePostal.elementValue = this._previousFieldValueCodePostal;

        this.useNomSpecifiqueMunicipaliteTextField = this._previousUseNomSpecifiqueMunicipaliteTextField;
        this.useNomSpecifiqueProvinceTextField = this._previousUseNomSpecifiqueProvinceTextField;
    }
    private updateSpecificNameTextFieldUsages(useNomSpecifiqueMunicipalite?: boolean, useNomSpecifiqueProvince?: boolean) {
        if (useNomSpecifiqueMunicipalite === true || useNomSpecifiqueMunicipalite === false) {
            this._previousUseNomSpecifiqueMunicipaliteTextField = this.useNomSpecifiqueMunicipaliteTextField;
            this.useNomSpecifiqueMunicipaliteTextField = useNomSpecifiqueMunicipalite;
        }
        if (useNomSpecifiqueProvince === true || useNomSpecifiqueProvince === false) {
            this._previousUseNomSpecifiqueProvinceTextField = this.useNomSpecifiqueProvinceTextField;
            this.useNomSpecifiqueProvinceTextField = useNomSpecifiqueProvince;
        }
    }
    private innerChanged(validateFieldsHasChanged?: boolean, changedFromEmbeddedField?: boolean) {
        validateFieldsHasChanged = validateFieldsHasChanged === true;
        changedFromEmbeddedField = changedFromEmbeddedField === true;

        this.elementValue = this.getTextualValue();
        //@@fetetrault: en test...

        if (this.canChangeEditMode) {
            if (!changedFromEmbeddedField) {
                this.editModeOn = false;
                this._formManagerParent.editModeChanged(this);
            }

            if (validateFieldsHasChanged && !this.anyFieldHasChanged())
                return;

            // if (!changedFromEmbeddedField)
            //     this.updatePreviousInnerFieldValues();//@@fetetrault: en test...            

            if (this.elementValue === this._previousValue)
                return;
        }

        // this.elementValue = this.getTextualValue();//@@fetetrault: en test...

        if (!changedFromEmbeddedField) {
            this.updatePreviousValue();
            //     this.updatePreviousInnerFieldValues();//@@fetetrault: en test...        
            this.$nextTick(() => {
                this._formManagerParent.fieldChanged(this);
            });
        }
    }
    private getPreviousFieldValueByName(name: string) {
        switch (name) {
            case this.fieldAdresse1.elementName:
                return this._previousFieldValueAdresse1;
            case this.fieldAdresse2.elementName:
                return this._previousFieldValueAdresse2;
            case this.fieldCodePostal.elementName:
                return this._previousFieldValueCodePostal;
            case this.fieldMunicipalite.elementName:
                return this._previousFieldValueMunicipalite;
            case this.fieldNomSpecifiqueMunicipalite.elementName:
                return this._previousFieldValueNomSpecifiqueMunicipalite;
            case this.fieldProvince.elementName:
                return this._previousFieldValueProvince;
            case this.fieldNomSpecifiqueProvince.elementName:
                return this._previousFieldValueNomSpecifiqueProvince;
            case this.fieldPays.elementName:
                return this._previousFieldValuePays;
        }
        return null;
    }
    private anyFieldHasChanged() {
        const textboxFields = this.getTextboxFields();
        const selectFields = this.getSelectFields();

        for (let i = 0; i < textboxFields.length; i++) {
            const f = textboxFields[i] as HotEditableTextboxComponent;
            const p = this.getPreviousFieldValueByName(f.elementName);
            const a = (f.elementValue || '').trim();
            const b = (p || '').trim();
            if (a !== b)
                return true;
        }

        for (let i = 0; i < selectFields.length; i++) {
            const f = selectFields[i] as HotEditableSelectComponent;
            const p = this.getPreviousFieldValueByName(f.elementName);

            if (!f.elementValue && !p)
                continue;

            if (!f.elementValue || !p)
                return true;

            const a = f.elementValue.code;
            const b = p.code;

            if (a !== b)
                return true;
        }

        return false;
    }

    /** Fonction éxécutée lorsque l'utilisateur clique sur le bouton d'édition */
    editClick(event?: Event, forcedMode?: boolean, fromPrevious?: boolean) {
        if (!this.canChangeEditMode)
            return;

        if (forcedMode === true || forcedMode === false) {
            this.editModeOn = forcedMode;
        } else {
            //toggle
            this.editModeOn = !this.editModeOn;
        }

        fromPrevious = fromPrevious === true;
        if (fromPrevious)
            this.fieldCodePostal.focus();
        else
            this.fieldAdresse1.focus();
    }

    onEnterClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event);
        this.changed();
    }

    onEscapeClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event);
        this.cancel();
    }

    onTabClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event);
        this.focusNextComponent();
    }

    onShiftTabClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event);
        this.focusNextComponent(true);
    }

    onBlur(event?: Event) {
        if (this.canChangeEditMode)
            this.preventDefault(event);
        this.blur();
    }

    blur() {
        this.innerChanged(true);
        //setTimeout(() => { this.changed(true); }, 250);
    }

    focus(fromPrevious?: boolean) {
        fromPrevious = fromPrevious === true;
        if (fromPrevious)
            this.fieldCodePostal.focus();
        else
            this.fieldAdresse1.focus();
    }

    private focusNextComponent(getPrevious?: boolean) {
        getPrevious = getPrevious === true;

        if (!this.canChangeEditMode)
            return false;

        this.innerChanged();
        //this.editClick(null, false);

        if (getPrevious)
            this._formManagerParent.focusPreviousComponentFromField(this)
        else
            this._formManagerParent.focusNextComponentFromField(this);
    }

    private onInnerFormChange(action: HotEditableFormAction) {

        const fieldName = action.getFieldName();

        if (fieldName === this.elementNameAdresse1 ||
            fieldName === this.elementNameAdresse2 ||
            fieldName === this.elementNameNomSpecifiqueMunicipalite ||
            fieldName === this.elementNameNomSpecifiqueProvince ||
            fieldName === this.elementNameCodePostal) {
            //== text boxes
            this.updateSummariesFromFields();
            this.innerChanged(null, true);
            return;
        }

        // autres (lorsque cest la dropdown qui est modifiee)
        this.safeFetch(() => {
            this.fetch(fieldName, true);
        });
    }

    private getHotEditableAddressApiArgumentsAsJson(selectedFieldName?: string) {
        const obj = this.getHotEditableAddressApiArguments(selectedFieldName);
        const json = JSON.stringify(obj);
        return json;
    }

    private getHotEditableAddressApiArguments(selectedFieldName?: string) {
        const a = {
            adresse1: this.fieldAdresse1.getTextualValue(),
            adresse2: this.fieldAdresse2.getTextualValue(),
            idMunicipalite: this.fieldMunicipalite.getTextualValue(),
            nomSpecifiqueMunicipalite: this.fieldNomSpecifiqueMunicipalite.getTextualValue(),
            idProvince: this.fieldProvince.getTextualValue(),
            nomSpecifiqueProvince: this.fieldNomSpecifiqueProvince.getTextualValue(),
            idPays: this.fieldPays.getTextualValue(),
            codePostal: this.fieldCodePostal.getTextualValue(),
            idEntity: this.idEntity,
            changedFieldName: selectedFieldName || null //NOTE: NULL => IsInitialCall=TRUE
        } as IHotEditableAddressApiArguments;

        return a;
    }

    private afterFetch() {
        this.isApiRunning = false;

        if (this.afterFetchAction)
            this.$nextTick(() => {
                this.afterFetchAction();
                this.afterFetchAction = null;
            });
    }

    private safeFetch(action: () => void) {
        if (this.isApiRunning) {
            this.afterFetchAction = action;
            return;
        }

        this.$nextTick(() => {
            action();
        });
    }

    private fetchWithValues(fireChanged: boolean, adresse1: string, adresse2: string, municipalite: string, nomSpecifiqueMunicipalite: string,
        province: string, nomSpecifiqueProvince: string, pays: string, codePostal: string, isInitialCall?: boolean) {
        const args = {
            adresse1: adresse1,
            adresse2: adresse2,
            idMunicipalite: municipalite,
            nomSpecifiqueMunicipalite: nomSpecifiqueMunicipalite,
            idProvince: province,
            nomSpecifiqueProvince: nomSpecifiqueProvince,
            idPays: pays,
            codePostal: codePostal,
            idEntity: this.idEntity,
            changedFieldName: null
        } as IHotEditableAddressApiArguments;

        this.innerFetch(args, fireChanged, isInitialCall);
    }

    private fetch(fieldName: string, fireChanged: boolean) {
        const args = this.getHotEditableAddressApiArguments(fieldName);

        this.innerFetch(args, fireChanged);
    }

    private innerFetch(args: IHotEditableAddressApiArguments, fireChanged: boolean, isInitialCall?: boolean) {
        isInitialCall = isInitialCall === true;
        const onError = (errors?: common.IError[], config?: common.IHotEditableFormConfig) => {
            errors = errors && errors.length ? errors : [new core.Error("Une erreur s'est produite lors de la collecte des données.")];
            HotEditableAddressComponent.displayError(errors[0]);
            this.afterFetch();
        };
        const postArguments = {
            Adresse1: args.adresse1 || '',
            Adresse2: args.adresse2 || '',
            IdMunicipalite: args.idMunicipalite || '',
            NomSpecifiqueMunicipalite: args.nomSpecifiqueMunicipalite || '',
            IdProvince: args.idProvince || '',
            NomSpecifiqueProvince: args.nomSpecifiqueProvince || '',
            IdPays: args.idPays || '',
            CodePostal: args.codePostal || '',
            IdEntity: args.idEntity || '',
            ChangedFieldName: args.changedFieldName || ''
        } as IHotEditableAddressApiArguments;

        this.isApiRunning = true;
        this._ajaxService.post(this.apiUrl, postArguments, true, (data: IHotEditableAddressApiResponseData) => {
            if (!data) {
                onError();
                return;
            }

            this.setFromApiResponse(data, isInitialCall);

            this.updateSummariesFromFields(data.useNomSpecifiqueMunicipaliteTextField, data.useNomSpecifiqueProvinceTextField);

            this.updatePreviousValue();
            if (isInitialCall)
                this.updatePreviousInnerFieldValues();//@@fetetrault: en test...

            if (fireChanged && !this.afterFetchAction)
                this.innerChanged(null, true);//NOTE: le 'elementValue' sera mis a jour a l'interieur du innerChanged
            else
                this.elementValue = this.getHotEditableAddressApiArgumentsAsJson(args.changedFieldName);

            this.afterFetch();

        }, onError);
    }

    private updateSummariesFromFields(useNomSpecifiqueMunicipalite?: boolean, useNomSpecifiqueProvince?: boolean) {

        this.updateSpecificNameTextFieldUsages(useNomSpecifiqueMunicipalite, useNomSpecifiqueProvince);

        const municipaliteValue = this.fieldMunicipalite.elementValue;
        const nomSpecMunicipaliteValue = this.fieldNomSpecifiqueMunicipalite.elementValue;
        const provinceValue = this.fieldProvince.elementValue;
        const nomSpecProvinceValue = this.fieldNomSpecifiqueProvince.elementValue;
        const paysValue = this.fieldPays.elementValue;

        this.adresse1Summary = this.fieldAdresse1.elementValue;
        this.adresse2Summary = this.fieldAdresse2.elementValue;
        this.codePostalSummary = this.fieldCodePostal.elementValue;
        this.municipaliteSummary = municipaliteValue ? municipaliteValue.label : nomSpecMunicipaliteValue;
        this.provinceSummary = provinceValue ? provinceValue.label : nomSpecProvinceValue;
        this.paysSummary = paysValue ? '(' + paysValue.label + ')' : '';

        if (this.summaryInlineMode) {
            const separator = ',&nbsp;';
            if (this.adresse1Summary)
                this.adresse1Summary += separator;
            if (this.adresse2Summary)
                this.adresse2Summary += separator;
            if (this.municipaliteSummary)
                this.municipaliteSummary += separator;
            if (this.provinceSummary && this.paysSummary)
                this.paysSummary += separator;
            else if (this.provinceSummary)
                this.provinceSummary += separator;
            else if (this.paysSummary)
                this.paysSummary += separator;
        }
    }

    private setFromApiResponse(data: IHotEditableAddressApiResponseData, isInitialCall?: boolean) {
        isInitialCall = isInitialCall === true;

        // Définir le contenu des listes déroulantes
        const municipalitesEtArrondissementsOptions = data.municipalitesEtArrondissementsOptions as common.ISelectOption[];
        this.updateSelectOptions(this.elementNameMunicipalite, municipalitesEtArrondissementsOptions, isInitialCall);
        const provincesOptions = data.provincesOptions as common.ISelectOption[];
        this.updateSelectOptions(this.elementNameProvince, provincesOptions, isInitialCall);
        const paysOptions = data.paysOptions as common.ISelectOption[];
        this.updateSelectOptions(this.elementNamePays, paysOptions, isInitialCall);

        this.fieldAdresse1.setFromTextualValue(data.adresse1);
        this.fieldAdresse2.setFromTextualValue(data.adresse2);
        this.fieldCodePostal.setFromTextualValue(data.codePostal);

        this.fieldNomSpecifiqueMunicipalite.setFromTextualValue(data.nomSpecifiqueMunicipalite);
        this.fieldNomSpecifiqueProvince.setFromTextualValue(data.nomSpecifiqueProvince);
    }

    private updateSelectOptions(fieldName: string, options?: common.ISelectOption[], updatePreviousValue?: boolean) {
        updatePreviousValue = updatePreviousValue === true;
        const r = HotEditableHelpers.convertToVueSelectOptions(options);
        const f = this.formManager.getFieldByName(fieldName) as HotEditableSelectComponent;

        f.options = r.options;
        f.setFromTextualValue(r.selectedValue ? r.selectedValue.code : null);

        if (updatePreviousValue)
            f.updatePreviousValue();
    }

    private static displayError(error: common.IError) {
        const manager = context.components.getMessagesManager();
        const m = {
            title: error.message,
            contentHtml: '',
            autoClose: false,
            messageSource: 'HotEditableAddressComponent',
            messageType: common.MessageTypes.error
        } as common.IMessage;

        manager.displayMessage(m, true);
    }

    private getTextboxFields() {
        return [
            this.fieldAdresse1,
            this.fieldAdresse2,
            this.fieldNomSpecifiqueMunicipalite,
            this.fieldNomSpecifiqueProvince,
            this.fieldCodePostal
        ];
    }

    private getSelectFields() {
        return [
            this.fieldMunicipalite,
            this.fieldProvince,
            this.fieldPays,
        ];
    }

    showMunicipalite(useNomSpecifiqueMunicipalite: boolean) {
        const show = !useNomSpecifiqueMunicipalite;
        if (this.fieldMunicipalite && this.fieldNomSpecifiqueMunicipalite) {
            if (show)
                this.fieldNomSpecifiqueMunicipalite.setFromTextualValue();
            else
                this.fieldMunicipalite.setFromTextualValue();
        }
        return show;
    }
    showNomSpecifiqueMunicipalite(useNomSpecifiqueMunicipalite: boolean) {
        const show = !!useNomSpecifiqueMunicipalite;
        if (this.fieldMunicipalite && this.fieldNomSpecifiqueMunicipalite) {
            if (show)
                this.fieldMunicipalite.setFromTextualValue();
            else
                this.fieldNomSpecifiqueMunicipalite.setFromTextualValue();
        }
        return show;
    }
    showProvince(useNomSpecifiqueProvince: boolean) {
        const show = !useNomSpecifiqueProvince;
        if (this.fieldProvince && this.fieldNomSpecifiqueProvince) {
            if (show)
                this.fieldNomSpecifiqueProvince.setFromTextualValue();
            else
                this.fieldProvince.setFromTextualValue();
        }
        return show;
    }
    showNomSpecifiqueProvince(useNomSpecifiqueProvince: boolean) {
        const show = !!useNomSpecifiqueProvince;
        if (this.fieldProvince && this.fieldNomSpecifiqueProvince) {
            if (show)
                this.fieldProvince.setFromTextualValue();
            else
                this.fieldNomSpecifiqueProvince.setFromTextualValue();
        }
        return show;
    }
    clearMessages() {
        const all = this.formManager.getMessageComponents();
        for (let i = 0; i < all.length; i++)
            all[i].clearMessage();
    }
}

export = HotEditableAddressComponent;